var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 192V320C0 337.625 14.375 352 32 352H96V160H32C14.375 160 0 174.375 0 192ZM608 160H128V352H608C625.625 352 640 337.625 640 320V192C640 174.375 625.625 160 608 160ZM320 280C306.75 280 296 269.25 296 256S306.75 232 320 232S344 242.75 344 256S333.25 280 320 280ZM416 280C402.75 280 392 269.25 392 256S402.75 232 416 232S440 242.75 440 256S429.25 280 416 280ZM512 280C498.75 280 488 269.25 488 256S498.75 232 512 232S536 242.75 536 256S525.25 280 512 280Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlute);
export default __webpack_public_path__ + "static/media/flute.f1f3fa41e5c92f00b32d01fbb320a1ab.svg";
export { ForwardRef as ReactComponent };